// GENERAL
export const API_CONFIGURABLE = "configurables/";

// USERS MANAGEMENT
export const API_PROFILE = "users/1";
export const API_USERS = "users/";
export const API_USER_ACCOUNT = "accounts/users/";
export const API_MERCHANTS = "users/merchants/";
export const API_MERCHANTS_USERS =
  "transact/customer-details/get-configurable-merchants-id/";
export const API_INTERNAL_MERCHANTS =
  "transact/customer-details/get-internal-merchants/";
// export const API_AGENTS = "users/agents/";
// export const API_PUBLIC_USERS = "users/public/";
export const API_USERS_LIST = "transact/users/list/";
export const API_CUSTOMER_REPORT_REQUESTS = "reports/customer-report-requests/";
export const API_APPLICATION_USERS = "applications/";
export const API_REJECTED_APPLICATION_USERS = "applications/?status=rejected";
export const API_APPROVE_AGENTS = "accounts/users/approve-agent/";
export const API_APPROVE_MERCHANTS = "accounts/users/approve-merchant/";
export const API_APPROVE_STAFF = "accounts/users/approve-staff-user/";
export const API_REJECT_USER = "accounts/users/reject-staff-user/";
export const API_REGISTER_AGENT = "accounts/users/create-agent/";
export const API_REGISTER_MERCHANT = "accounts/users/create-merchant/";
export const API_REGISTER_STAFF = "accounts/users/create-staff-user/";
export const API_LOGIN = "accounts/users/authenticate/";
export const API_OTP_VERIFICATION = "accounts/users/authenticate/";
export const API_PIN_RESET_REQUEST = "accounts/users/reset-pin-request/";
export const API_PIN_RESET = "accounts/users/reset-pin/";
export const API_PIN_SET = "accounts/users/set-pin/";
export const API_RESET_PASSWORD = "password_reset/confirm/";
export const API_VERIFY_PASSWORD_RESET_TOKEN = "password_reset/validate_token/";
export const API_REQUEST_PASSWORD_RESET = "password_reset/";
export const API_ACCOUNTS_ROLES = "role/";
export const API_ACCOUNTS_ROLES_REGISTER = "role/";
export const API_ACCOUNTS_CREATION_ROLES = "role/all/";
export const API_ACCOUNTS_PROFILES = "accounts/profiles/";
export const API_CHANGE_PASSWORD = "accounts/users/change-password/";
export const API_FIELD_OFFICERS = "/loan-applications/field-officers/";

//LOAN APPLICATIONS
export const API_LOAN_APPLICATIONS = "loan-applications/";
export const API_LOAN_APPLICATIONS_DRAFTS = "loan-applications/drafts/";
export const API_LOAN_APPLICATIONS_RESCHEDULE =
  "loan-applications/reschedules/";
// INVENTORY MANAGEMENT
export const API_PURCHASE_ORDERS = "purchase-orders/";
export const API_BULK_PURCHASE_ORDERS = "purchase-orders/bulk-upload/";
export const API_BULK_PURCHASE_ORDERS_TEMPLATE =
  "order-inventories/batch-products-upload-template/";
export const API_PURCHASE_ORDER_ITEMS = "order-inventories/";
export const API_INVENTORY = "inventories/";
export const API_INVENTORY_ALL = "inventories/all/";
export const API_PRODUCTS = "products/";

// PAYROLL MANAGEMENT
export const API_PAYROLL = "payrolls/";

//LOCATION DETAILS
export const API_DISTRICTS = "districts/";
export const API_COUNTIES = "counties/";
export const API_SUB_COUNTIES = "sub-counties/";
export const API_PARISHES = "parishes/";
export const API_VILLAGES = "villages/";
export const API_REGIONS = "regions/";

export const API_DISTRICTS_PAGINATED = "districts/";
export const API_COUNTIES_PAGINATED = "counties/";
export const API_SUB_COUNTIES_PAGINATED = "sub-counties/";
export const API_PARISHES_PAGINATED = "parishes/";
export const API_VILLAGES_PAGINATED = "villages/";
export const API_REGIONS_PAGINATED = "regions/";

//CONFIGURABLES
export const API_CONFIGURABLES = "transact/configurations/";
export const API_INTEREST_CONFIGURABLES =
  "configurables/interest-configurations/";
export const API_PERIOD_CONFIGURABLES =
  "configurables/loan-validity-period-configurations/";
export const API_FEES_CONFIGURABLES =
  "configurables/fees-schedule-configurations/";
export const API_CHARTS_OF_ACCOUNTS = "reports/webview/chart-of-accounts/";
export const API_CHARTS_OF_ACCOUNTS_PARENT_ACCOUNTS =
  "accounting/chart-of-accounts/parent-accounts/";
export const API_CHARTS_OF_ACCOUNTS_ALL = "accounting/charts-of-accounts/all/";
export const API_SUPPLIER_CONFIGURABLES = "configurables/suppliers/";
export const API_PAYMENT_MODES_CONFIGURABLES = "payments/payment-modes/";
export const API_ALLOWANCE_TYPE_CONFIGURABLES =
  "configurables/allowance-types/";
export const API_MERCHANT_INDUSTRIES_CONFIGURABLES =
  "merchant-configurables/industries/";
export const API_MERCHANT_BUSINESS_CONFIGURABLES =
  "merchant-configurables/business-classifications/";

//VALIDATE NIN
export const VALIDATE_NIN_API = `accounts/register-user/validate-nin/`;
export const VALIDATE_BRN_API = `accounts/register-user/validate-nin/`;
export const VALIDATE_TIN_API = `accounts/register-user/validate-nin/`;

// AUDIT ACTIVITY
export const API_AUDIT_ACTIVITY = "audit-trails/";
export const API_SECURITY_ACTIVITY = "security-activity/";
export const API_BUSINESS_AUDIT_LOGS = "transact/business-audit-logs/";

// OFFICES
export const API_DEPARTMENTS = "departments/";

// ORGANISATIONS
export const API_ORGANISATIONS = "organisations/";
// Accounts
export const API_LEDGERS = "accounting/general-ledger/";

// Expenses
export const API_EXPENSES = "expenses/";

// Requisitions
export const API_REQUISITIONS = "requisitions/";

// Other Income
export const API_OTHER_INCOME = "other-incomes/";
// Payments
export const API_INVOICES = "billings/invoices/";
export const API_PRNS = "payments/prns/";
export const API_MOCK_PAYMENTS = "payments/payments/mock-invoice-payment/";
export const API_COMPOSITE_ITEMS = "transact/composite-payment-items/";
export const API_PAYMENT_ITEMS_CONFIGURABLE = "transact/payment-item/list/";
export const API_ACTIVE_PARTNERS = "transact/partners/active/";
export const API_MERCHANTS_CONFIGURABLE =
  "transact/customer-details/get-configurable-merchants/";
// REPORTS
export const API_REPORTS_DASHBOARD = "reports/dashboard/";
export const API_REPORTS_ACCOUNT_STATEMENT =
  "reports/account-statement-report/";
export const API_GENERATE_API_KEY = "transact/generate_api_key/";
export const API_DISBURSEMENT_SETTINGS = "api/disbursement/set-settings/";
export const API_REPORTS_DAILY_SALES = "reports/sales-report/";
export const API_BILLINGS_INVOICE_LIST_REPORT =
  "billings/instalments/invoice-list-report/";
export const API_LOAN_BOOK_REPORT = "reports/loan-book-report/";
export const API_EXPENSES_REPORT = "reports/expenses/";
export const API_TRANSACTIONS_HISTORY = "reports/accounts-transactions/";
export const API_TRANSACTIONS_HISTORY_EXPORT =
  "reports/accounts-transactions-export/";
export const API_TRANSACTIONS_LISTS_EXPORTS =
  "reports/transaction-list-report-excel/";

//SYSTEM REPORTS
export const API_UTILITY_LOGS = "reports/utility-requests";

// PERMISSIONS
export const API_ACCOUNTS_PERMISSIONS = "accounts/permissions/";
export const API_PERMISSIONS = "permissions/";

// SERVICES
// export const API_PAYMENT_ITEM = "transact/payment-item/create/";
export const API_UPDATE_PAYMENT_ITEM = "transact/payment-item/";
export const API_PAYMENT_ITEM_LIST = "transact/payment-item/";
export const API_PAYMENT_ITEM_LIST_ACTIVE = "transact/payment-item/active/";
export const API_PARTNERS = "transact/partners/";
export const API_PARTNERS_LIST = "transact/partners/list/";
export const API_MECHANT_FEES = "transact/merchant-fees/";
export const API_MERCHANT_FEES_LIST = "transact/merchant-fees/";
export const API_MERCHANT_SERVICE_ACCESS = "transact/merchant-service-access/";
export const API_CUSTOMER_CONFIGURABLE_MERCHANTS =
  "transact/customer-details/get-configurable-merchants/";

//CHARGES
export const API_YOYA_CHARGES = "transact/yoya-charges/";
export const API_TIERED_CHARGES =
  "transact/merchant-tiered-charges/create_tiered_charge/";
export const API_PARTNER_CHARGES = "transact/partner-charges/";

export const API_PAYMENTS = "payments/payments/";
export const API_PAYMENT_METHODS = "payments/payment-modes/";

// Exports
export const API_LEDGERS_EXPORT = "accounting/general-ledger/excel-export/";
export const API_FINES_EXPORT = "reports/fines/";
// Reports Exports
export const API_CASH_FLOW_EXPORT = "reports/cash-flow-statement-excel/";
export const API_FINANCIAL_POSITION_EXPORT =
  "reports/financial-position-excel/";
export const API_PROFIT_AND_LOSS_EXPORT =
  "/reports/profit-and-loss-statement-excel/";
export const API_LOAN_APPLICATIONS_REPORT = "reports/loan-applications-report/";
export const API_LOAN_APPLICATIONS_REPORT_EXPORT =
  "reports/loan-applications-report/excel-export/";

// PAYMENT SERVICES
export const API_PAYMENT_SERVICE = "transact/item-service-menu/";
export const API_PAYMENT_SERVICE_MENU = "transact/service-menu-management/";
export const API_UPDATE_PAYMENT_SERVICE = "transact/item-service-menu/";
export const API_PAYMENT_SERVICE_LIST = "transact/payment-item/list/";

export const API_MERCHANT_IP_WHITELIST = "transact/merchant-ip-whitelist/";

export const API_MERCHANTS_APPROVED = "transact/active-merchants/";

//WALLET TRANSFERS
export const API_ALL_WALLET_TRANSACTIONS = "reports/transactions/";
export const API_WALLET_TRANSACTIONS = "reports/user-transactions/";
export const API_WALLET_DEPOSIT = "transact/deposit-request/";
export const API_CHARGE_ASSIGNMENT = "transact/who-incurs-charges/";
export const API_SYSTEM_WALLETS_LIST = "transact/systemwallets/list-wallets/";
export const API_SYSTEM_WALLETS_CHART_ASSIGNMENT =
  "transact/system-wallets-chart-assignment/";

//FINANCE AND TREASURY
export const API_SETTLEMENT_ELIGIBILITY =
  "settlement/batches/eligibility_preview/";
export const API_FLOAT_INTEREST = "float-interest/";
export const API_FLOAT_INTEREST_CONFIGS = "float-interest-configs/";
export const API_FLOAT_INTEREST_STATEMENT_PROCESS =
  "float-interest-configs/process/";
export const API_FLOAT_INTEREST_STATEMENTS = "float-interest-statements/";
export const API_SETTLEMENT_BATCHES = "settlement/batches/";
export const API_SETTLEMENT_BATCHES_SUBMIT = "settlement/batches/submit/";
export const API_SETTLEMENT_BATCHES_DECIDE = "settlement/batches/decide/";
export const API_SETTLEMENT_BATCHES_EXECUTE = "settlement/batches/execute/";
export const API_SETTLEMENT_BATCHES_RETRY = "settlement/batches/retry/";
export const API_SETTLEMENT_RULES = "settlement/rules/";
export const API_SETTLEMENT_BENEFICIARIES = "settlement/beneficiaries/";
export const API_SETTLEMENT_APPROVALS = "settlement/batches/approval_queue/";
export const API_SETTLEMENT_MY_APPROVALS = "settlement/batches/my_queue/";

// Transaction Processing
export const API_REVERSE_TRANSACTIONS = "transact/reversal-requests/";
export const API_PARTNER_ITEM_MAPPING = "transact/item-partners/";
export const API_MARK_TRANSACTION = "transact/mark-transaction/";
export const API_LIQUIDATIONS = "transact/debit-holdings/";
export const API_DEBIT_HOLDINGS = "transact/debit-holdings/";
export const API_CREDIT_HOLDINGS = "transact/credit-holdings/";
export const API_CREDIT_HOLDING_TYPES = "credit-holding-types/";
export const API_DEBIT_HOLDINGS_TYPES = "debit-holdings-types/";
export const API_LIQUIDATION_BANK_CODES = "liquidation-bank-codes/";
export const API_AVAILABLE_LIQUIDATION_BANK_CODES =
  "get_available_liquidation_bank_codes/";
export const API_BANK_ACCOUNTS = "bank-accounts/";

export const API_WALLET_DEPOSIT_CONFIRM = "transact/deposit-confirm/";
export const API_WALLET_TRANSFER = "transact/wallet-transfer-request/";
export const API_WALLET_TRANSFER_CONFIRM = "transact/wallet-transfer-confirm/";

//PAYMENT TYPES
export const API_PAYMENT_TYPES = "transact/payment-types/";

//FLOAT MANAGEMENT
export const API_REPLENISHMENT = "transact/credit-holdings/";
export const API_MONITORED_ACCOUNTS = "monitored-accounts/";
export const API_WALLETS = "list_accounts_to_monitor/";
export const API_ACCOUNT_ALERTS = "list_monitored_accounts/";

//WORKFLOWS
export const API_WORKFLOWS = "transact/workflows/";
export const API_SCRUTNIY_WORKFLOWS =
  "transact/scrutiny-workflow-configurables/";

//RECONCILIATIONS REPORTS
export const API_RECONCILIATIONS_REPORTS = "reports/user-transactions/";

// PAYMENT ACCESS MATRIX
export const API_INTERNAL_MERCHANT_ACCESS =
  "transact/internal-merchant-service-access/";

//MERCHANT USERS
export const API_MERCHANT_USERS = "accounts/users/merchant/create-user/";
export const API_MERCHANT_USERS_LIST = "accounts/users/merchant/sub-users/";
export const API_TRANSACTION_MONITORING = "reports/transaction-summary/2/";
export const API_RECONCILIATION_STATEMENTS =
  "reports/reconciliation-statements/";

export const API_SYSTEM_WALLETS = "transact/systemwallets/";

//LIQUIDATIONS CONFIGURABLE
export const API_LIQUIDATIONS_CONFIGURABLE = "liquidation-configurations/";
export const API_LOAD_LIQUIDATIONS_MERCHANT =
  "liquidation-configurations/load-merchants-to-liquidate/";
// QR CODE PAYMENTS
export const API_QR_CODE = "qrcodes/";
export const API_QR_CODE_PAYMENTS = "qrcode-payments/";
export const API_QR_CODE_PAYMENT_ITEMS = "qrcodes/get-payment-items/";
export const API_QR_CODE_RECEIPT_CONFIGURATIONS =
  "qrcode-receipt-configurations/";
export const API_QR_CODE_MERCHANT_SERVICES = "qrcode-merchant-services/";

//LIQUIDATION LOGS
export const API_LIQUIDATION_LOGS = "liquidation-logs/";

//MERCHANT CODES
export const API_MERCHANT_CODES = "merchant/merchant-payment-codes/";
export const API_CHECK_STATIC_QR_CODE = "qrcodes/has-static-qr-code";
export const API_GENERATE_MERCHANT_PAYMENT_CODE =
  "merchant/merchant-payment-codes/generate-payment-code/";
export const API_USER_TRANSACTIONS = "reports/user-transactions/";

// FRAUD DETECTION
export const API_FRAUD_RULES = "fraud/rules/";
export const API_FRAUD_EVENTS = "fraud/events/";
export const API_FRAUD_RISK_TRENDS = "fraud/events/sus-txns/";
export const API_FRAUD_RULES_HISTORY = "fraud/rules-history/";
export const API_FRAUD_DASHBOARD_EVENTS = "fraud/events/dashboard/";
export const API_FRAUD_AUDIT_LOGS = "fraud/audit-logs/";

export const API_FRAUD_WEIGHT_SCORE = "fraud/score-weights/";
export const API_FRAUD_ALERTS = "fraud/alerts/";
export const API_FRAUD_CASES = "fraud/cases/";
export const API_FRAUD_RULE_TEMPLATES = "fraud/templates/";
export const API_FRAUD_CONFIGURATIONS = "fraud/configurations/";

// MERCHANT PAYMENTS
export const API_MERCHANT_PAYMENTS = "merchant/merchant-payments/";
export const API_MERCHANTS_NUMBER =
  "transact/customer-details/get-configurable-merchants/";
export const API_GET_CONFIGURABLE_MERCHANTS_ID =
  "transact/customer-details/get-configurable-merchants-id/";

// API INTEGRATION
export const API_INTEGRATION = "iframe-secure-form/embed/";
export const API_REQUEST_PUBLIC_KEY = "iframe-merchant/";

//IFRAME PAYMENTS
export const API_IFRAME_PAYMENTS = "iframe-payments/";

//APPLICATIO STATUS
export const API_APPLICATION_STATUS = "applications/status/";
export const API_ENQUIRIES_STATUS = "contact-us/contact-us-status/";

// DISBURSEMENT SERVICE
export const API_DISBURSEMENT_OUTGOING_REQUESTS =
  "disbursement/outgoing-requests/";
export const API_DISBURSEMENT_INCOMING_REQUESTS =
  "disbursement/incoming-requests/";
export const API_DISBURSEMENT_TRANSACTION_LOGS =
  "disbursement/transaction-logs/";
export const API_DISBURSEMENT_CUSTOMER_DETAILS =
  "disbursement/customer-details/";
export const API_DISBURSEMENT_ERROR_LOGS = "disbursement/error-logs/";

//USSD SERVICES
export const API_SET_USSD_MERCHANT = "ussdreports/upsert-merchant";
export const API_USSD_INPUT_LOGS = "ussdreports/ussd-input-logger";
export const API_USSD_CUSTOMER_TRANSACTIONS =
  "ussdreports/customer-transactions";
export const API_USSD_INCOMING_LOGS = "ussdreports/incoming";
export const API_USSD_OUTGOING_LOGS = "ussdreports/outgoing";
export const API_USSD_CONFIGURABLES = "ussdreports/upsert-configurable";
export const API_USSD_SAFEGUARDS = "ussdreports/transaction-safeguards";

//TRANSACTION SUMMARY
export const API_MONTHLY_SUMMARY_REPORTS =
  "reports/monthly-transaction-summary/";
export const API_MONTHLY_MERCHANT_VELOCITY_REPORTS =
  "reports/merchant-monthly-velocity-reports/";
export const API_MONTHLY_PAYMENT_VELOCITY =
  "reports/payment-item-monthly-velocity-reports/";
export const API_DAILY_PAYMENT_ITEM_SUMMARY =
  "reports/payment-item-daily-velocity-reports/";
export const API_DAILY_MERCHANT_SUMMARY =
  "reports/merchant-daily-velocity-reports/";
export const API_DAILY_TRANSACTION_SUMMARY =
  "reports/daily-transaction-summary/";
export const API_MONTHLY_TRANSACTION_SUMMARY =
  "reports/monthly-transaction-summary/";

//URA PAYMENTS
export const API_QUERY_CUSTOMER = "transact/query-customer/";
export const API_MAKE_PAYMENT = "transact/make-payment/";

//REPORTS
export const TRIAL_BALANCE_API = "reports/trial-balance/";
export const TRANSACTION_CHANNEL_SEPARATION_API =
  "reports/transaction-channel-separation/";
export const COMMISSIONS_REPORT_API = "reports/agent-commissions/";
export const PARTNER_DAILY_COMMISSIONS_REPORT_API =
  "reports/partner-daily-commission-reports/";
export const PARTNER_MONTHLY_COMMISSIONS_REPORT_API =
  "reports/partner-monthly-commission-reports/";
export const AGENT_DAILY_COMMISSIONS_REPORT_API =
  "reports/agent-daily-commission-reports/";
export const AGENT_MONTHLY_COMMISSIONS_REPORT_API =
  "reports/agent-monthly-commission-reports/";
export const YOYA_DAILY_COMMISSIONS_REPORT_API =
  "reports/yoya-daily-commission-reports/";
export const YOYA_MONTHLY_COMMISSIONS_REPORT_API =
  "reports/yoya-monthly-commission-reports/";
export const DAILY_TRANSACTION_CHANNEL_SEPARATION =
  "reports/daily-transaction-channel-separation/";
export const MONTHLY_TRANSACTION_CHANNEL_SEPARATION =
  "reports/monthly-transaction-channel-separation/";
export const DAILY_PAYMENT_ITEM_CHANNEL_REPORT =
  "reports/daily-payment-item-channel-report/";
export const MONTHLY_PAYMENT_ITEM_CHANNEL_REPORT =
  "reports/monthly-payment-item-channel-report/";
export const INCIDENT_TICKET_CATEGORY_REPORT =
  "reports/incident-ticket-category/";
export const INCIDENT_TICKET_SEVERITY_REPORT =
  "reports/incident-ticket-severity/";

//SUPPORT
export const API_TICKET_CATEGORIZATION = "incident-categories/";
export const INCIDENT_TICKETING_API = "incident-tickets/";
export const API_TICKET_CATEGORIZATION_LIST = "incident-categories-menu-list/";
export const RAISED_TICKETS_API = "get-raised-tickets/";
export const ASSIGNED_TICKETS_API = "get-assigned-tickets/";
export const TICKETABLE_USERS_API = "get-ticketable-users/";
//CONTACT US
export const API_CREATE_ENQUIRIES = "contact-us-create/";
export const API_ENQUIRIES = "contact-us/";
